import React from "react";
import { Instagram, Facebook } from "lucide-react";
import { useLang } from "../../lib/i18n";

const socials = [
  { label: "Instagram", href: "https://instagram.com/shamar.conciergerie", Icon: Instagram },
  { label: "Facebook", href: "https://facebook.com/shamar.conciergerie", Icon: Facebook },
];

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="relative bg-[#050B14] py-16 overflow-hidden" data-testid="site-footer">
      <div className="noise-overlay" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row justify-between gap-12">
          <div>
            <img src="/logo-shamar-light.png" alt="Shamar — Services sur mesure" className="h-24 w-auto mb-5" data-testid="footer-logo" />
            <p className="text-[#F0F0F0]/40 text-sm font-light max-w-xs leading-relaxed">{t.footer.desc}</p>
            <div className="flex items-center gap-4 mt-6" data-testid="footer-socials">
              {socials.map(({ label, href, Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={`social-${label.toLowerCase()}`}
                  className="w-10 h-10 flex items-center justify-center border border-white/10 text-[#F0F0F0]/60 hover:border-[#C9A03C] hover:text-[#C9A03C] transition-colors duration-300"
                >
                  <Icon className="w-4 h-4" strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-12">
            <div>
              <h4 className="text-[#C9A03C] text-xs tracking-[0.2em] uppercase mb-4">{t.footer.navTitle}</h4>
              <ul className="space-y-2.5 text-sm text-[#F0F0F0]/60 font-light">
                <li><a href="#piliers" className="hover:text-[#C9A03C] transition-colors duration-300">{t.footer.links.piliers}</a></li>
                <li><a href="#experiences" className="hover:text-[#C9A03C] transition-colors duration-300">{t.footer.links.experiences}</a></li>
                <li><a href="#galerie" className="hover:text-[#C9A03C] transition-colors duration-300">{t.footer.links.table}</a></li>
                <li><a href="#reserver" className="hover:text-[#C9A03C] transition-colors duration-300">{t.footer.links.reserver}</a></li>
                <li><a href="#devis" className="hover:text-[#C9A03C] transition-colors duration-300">{t.footer.links.devis}</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-[#C9A03C] text-xs tracking-[0.2em] uppercase mb-4">{t.footer.contactTitle}</h4>
              <ul className="space-y-2.5 text-sm text-[#F0F0F0]/60 font-light">
                <li><a href="tel:0766230145" className="hover:text-[#C9A03C] transition-colors duration-300">07 66 23 01 45</a></li>
                <li><a href="mailto:contact@shamar-services.com" className="hover:text-[#C9A03C] transition-colors duration-300">contact@shamar-services.com</a></li>
                <li className="text-[#F0F0F0]/40">{t.footer.zone}</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-4 text-xs text-[#F0F0F0]/30 font-light tracking-wide">
          <span>© {new Date().getFullYear()} Shamar — {t.footer.copyright}</span>
          <span className="font-script text-lg text-[#C9A03C]/60">{t.footer.tagline}</span>
        </div>
      </div>
    </footer>
  );
};
